import { render, staticRenderFns } from "./TabelaResultado.vue?vue&type=template&id=141fdf24"
import script from "./TabelaResultado.vue?vue&type=script&lang=js"
export * from "./TabelaResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports